import React, { useEffect, useState } from 'react'
import {Button, Col, Layout, Row, Select, Space, Typography} from 'antd'
import {useHistory} from 'react-router-dom'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import axios from 'axios'
import {format, parseISO} from 'date-fns'
import { useRequestContext } from '../Contexts/RequestContext'
import AppLayout from '../Components/Layouts'
import BitTable from '../Components/BitTable'
import PageTitle from '../Components/PageTitle'
import SearchFilter, { FilterByStatus, PageSizeSelect, Search } from '../Components/SearchFilter'
import { FETCH_BUY_REQUEST } from '../Contexts/type'

const {REACT_APP_BASE_URL} = process.env


// // PageFilters
// function PageSizeSelect(params) {
//     function handleChange(value) {
//         console.log(`selected ${value}`);
//       }

//     const {Option} = Select
//     return (
//         <>
//         <Select defaultValue="10" style={{ width: 120 }} showArrow onChange={handleChange}>
//           <Option value="10">10/Page</Option>
//           <Option value="20">20/Page</Option>
//           <Option value="50">50/Page</Option>
//           <Option value="100">100/Page</Option>
//         </Select>
//        </>
//     );
// }

function Users() {
   const {Content} = Layout
   const history = useHistory()
   const {state, dispatch } =  useRequestContext()
   const [users, setUsers] = useState([])
   const [tableData, setTableData] = useState([])

//   Filter States
   const [pageSize, setPageSize] = useState(10)
   const [statusFilter]= useState('All')

   async function getUsers() {

    if(state && Array.isArray(state.users) && state.users.length > 0) {
        const br = state.users.map(row => ({
            key: row._id.toString(),
            location: row.delivery && row.delivery.address ? row.delivery.address  : '',
            date: format(parseISO(row.createdAt), 'MM-dd-yyyy') ,
            time: format(parseISO(row.createdAt), 'HH:mm:ss aaaa'),
            ...row
        })
        );
         setUsers(br)
         setTableData(br)
         return;
    }
    const url = REACT_APP_BASE_URL + 'admins/users'
   try {
    const token = window.localStorage.getItem('s_token')
    if(!token || typeof token === 'undefined' || token === null) return

    const response = await axios.get(url,{
    headers: {
        'Authorization': `Bearer ${token}`
    }
    })
  console.log(response.data)
    if(response.status === 200 && response.data && Array.isArray(response.data.users)) {
        let u = response.data.users
         u = u.map(row => ({
            key: row._id.toString(),
            name: row.firstName + ' ' + row.lastName,
            email: row.email,
            location: row.delivery && row.delivery.address ? row.delivery.address  : '',
            date: format(parseISO(row.createdAt), 'MM-dd-yyyy') ,
            time: format(parseISO(row.createdAt), 'HH:mm:ss'),
            ...row
        })
        );
        // dispatch
        // dispatch({
        //     type: FETCH_BUY_REQUEST,
        //     users: response.data
        // })

       
        setUsers(u)
        setTableData(u)
    }

   } catch (error) {

    // alert an error message
     setUsers([])
     setTableData([])
   } 
}

useEffect(() => {
    getUsers()
}, [])


/*  ------------
----------------PAGE FILTERS ----------
--------------------------------------- */

// Handle Page SizeChange
function handleChange(value) {
    console.log(`selected ${value}`);
    setPageSize(+value)
  }


//   Handle Status Filter
const statusOptions = [
    {
        label: 'All',
        value: -1
    },
    {
        label: 'Active',
        value: true
    },
    {
        label: 'Deactivated',
        value: false
    }
] 

function handleStatusChange(value) {
    if(value !== -1){
        const ds = users.filter((br) =>  br && br.active === value)
        setTableData(ds)
        return
    }
    setTableData(users)
      
}


// Name Search
// Name Search
function onSearch(value) {

    const found =  users.filter(u => u.firstName.toLowerCase().includes(value.toLowerCase()) || u.lastName.toLowerCase().includes(value.toLowerCase()) )
  
    if(found.length > 0) {
        setTableData(found)
        return
    } 
    else
    if(value.length === 0) {
        setTableData(users)
    }
    else
    if(found.length === 0) {
        setTableData([])
        return
    }
    
}

const btnStyle = {paddingRight:'.3rem', paddingLeft:'.3rem', backgroundColor: '#F5F5F5', display: 'flex', alignItems: 'center'} 
const columns = [
    {
        key: 'name',
        dataIndex: 'name',
        title: 'Name'
    },
    {
        key: 'phone',
        dataIndex: 'phone',
        title: 'Phone.no'
    },
    {
        key: 'email',
        dataIndex: 'email',
        title: 'Email address'
    },
    {
        key: 'date',
        dataIndex: 'date',
        title: 'Date joined'
    },
    {
        key: 'active',
        dataIndex: 'active',
        title: 'Status',
        render: (text, record) => {
            
            return record && record.active === true ? (
                <Typography.Text style={{color: '#049A50'}}>Active</Typography.Text>
            )
            :
            (
                <Typography.Text style={{color: '#D80027'}}>Deactivated</Typography.Text>
            )
        }
    },
  
]

    return (
        <AppLayout>
            <Content>
                {/* Page Header */}
                <PageTitle title='Users' />

                {/* Page Content */}
                <div className='bit-my bit-col' style={{flexDirection: 'column'}}>
                    <SearchFilter 
                      pageSizeFilter={{
                        enabled: true,
                        render: <PageSizeSelect handleChange={handleChange} />
                      }} 
                      statusFilter={{
                          enabled: true,
                          render: <FilterByStatus defaultValue={statusFilter} options={statusOptions} handleChange={handleStatusChange} />
                      }}
                      
                      searchFilter= {<Search  onSearch={onSearch} />}
                     
                    />
                <Row >
                    <Col style={{width: '100%'}}>
                        <BitTable 
                          dataSource={tableData} 
                          columns={columns} 
                          onRow={(record, rowIndex) => {
                            return {
                              onClick: event => { history.push(`/users/${record.key}`)}, // click row
                              onDoubleClick: event => {}, // double click row
                              onContextMenu: event => {}, // right button click row
                              onMouseEnter: event => {}, // mouse enter row
                              onMouseLeave: event => {}, // mouse leave row
                            };
                            }
                           }
                          pagination={{ 
                              total: tableData.length,
                              // showSizeChanger: true,
                              // showQuickJumper: true,
                              showTotal: (total, range) => `Viewing ${range[0]}-${range[1]} of ${total}`,
                              defaultPageSize: pageSize,
                              pageSize,
                              defaultCurrent: 1
                            }} 
                            />
                    </Col>
                </Row>
              </div>
            </Content>
        </AppLayout>
    )
}

export default Users
